import { FlowsMoveAcquisitionPrivateSwitchModel } from "./flows-move-acquisition-private-switch.model";

export namespace FlowsMoveAcquisitionPrivateSwitchAction {
  export namespace Fetch {
    export class Consumption {
      static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Fetch.Consumption";
      constructor(public payload: FlowsMoveAcquisitionPrivateSwitchModel) {}
    }
    export class GridArea {
      static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Fetch.GridArea";
      constructor(public gridArea: string) {}
    }
    export class PostalCode {
      static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Fetch.PostalCode";
      constructor(public postalCode: string) {}
    }
  }
  export class Loading {
    static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Loading";
    constructor(public state: "loading-postalcode" | "loading-gridarea" | "loading-consumption") {}
  }
  export class Errorred {
    static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Errorred";
    constructor(public message: string, public error: "fetch-postalcode" | "fetch-gridarea" | "fetch-consumption") {}
  }
  export class Changed {
    static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Changed";
    constructor(public payload: FlowsMoveAcquisitionPrivateSwitchModel) {}
  }
  export class Submitted {
    static readonly type = "[FlowsMoveAcquisitionPrivateSwitch] Submitted";
    constructor(public payload: FlowsMoveAcquisitionPrivateSwitchModel) {}
  }
}
